import React from "react";
import AdminActionButton from "../../components/admin/AdminActionButton";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import EditIcon from '@mui/icons-material/Edit';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import PostAddIcon from '@mui/icons-material/PostAdd';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ChecklistIcon from '@mui/icons-material/Checklist';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import EventIcon from '@mui/icons-material/Event';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';

import { Box, Typography, useTheme } from "@mui/material";

const AdminPanel = () => {
    const theme = useTheme();

    return (
        <Box sx={{ px: 2, py: 4 }}>
            <Typography
                variant="h4"
                sx={{
                    color: theme.palette.accent.main,
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 4,
                }}
            >
                admin panel
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: 2,
                    maxWidth: "1200px",
                    mx: "auto",
                }}
            >
                <AdminActionButton name="add items" icon={<LibraryAddIcon sx={{ fontSize: 50 }} />} routeName="addItems" />
                <AdminActionButton name="edit items" icon={<EditIcon sx={{ fontSize: 50 }} />} routeName="editItems" />
                <AdminActionButton name="add trades" icon={<PostAddIcon sx={{ fontSize: 50 }} />} routeName="addTrades" />
                <AdminActionButton name="paste trades" icon={<ContentPasteGoIcon sx={{ fontSize: 50 }} />} routeName="pasteTrades" />
                <AdminActionButton name="view trades" icon={<VisibilityIcon sx={{ fontSize: 50 }} />} routeName="viewTrades" />
                <AdminActionButton name="edit trades" icon={<EditNoteIcon sx={{ fontSize: 50 }} />} routeName="editTrades" />
                <AdminActionButton name="delete trades" icon={<DeleteOutlineIcon sx={{ fontSize: 50 }} />} routeName="deleteTrades" />
                <AdminActionButton name="mark rr" icon={<AnnouncementIcon sx={{ fontSize: 50 }} />} routeName="markRR" />
                <AdminActionButton name="mark notes" icon={<NoteAltIcon sx={{ fontSize: 50 }} />} routeName="markNotes" />
                <AdminActionButton name="make petpage" icon={<TextSnippetIcon sx={{ fontSize: 50 }} />} routeName="makePetpage" />
                <AdminActionButton name="migrate data" icon={<DriveFolderUploadIcon sx={{ fontSize: 50 }} />} routeName="migrateData" />
                <AdminActionButton name="neoboards source parser" icon={<ManageSearchIcon sx={{ fontSize: 50 }} />} routeName="neoboardsSourceParser" />
                <AdminActionButton name="dashboard" icon={<LeaderboardIcon sx={{ fontSize: 50 }} />} routeName="dashboard" />
                <AdminActionButton name="manage options" icon={<ChecklistIcon sx={{ fontSize: 50 }} />} routeName="manageOptions" />
                <AdminActionButton name="update userscript" icon={<WorkHistoryIcon sx={{ fontSize: 50 }} />} routeName="updateUserscript" />
                <AdminActionButton name="manage events" icon={<EditCalendarIcon sx={{ fontSize: 50 }} />} routeName="manageEvents" />
                <AdminActionButton name="view events" icon={<EventIcon sx={{ fontSize: 50 }} />} routeName="viewEvents" />
            </Box>
        </Box>
    );
};

export default AdminPanel;
